import { api } from 'app/utils/api/helpers'

export const getShareApplicationDetails = (shortcode) => {
  return api.get(`/sm/shareapplication/${shortcode}`)
}
